import withGlobalWrapper from 'components/globalWrapper'

import Baercode from 'pages/baercode'

const ReactPage = withGlobalWrapper(Baercode)

export default ReactPage
